// extracted by mini-css-extract-plugin
export var copyableField = "_mp-4";
export var customerBadge = "_mp-0";
export var customerInfoTitle = "_mp-2";
export var details = "_mp-1";
export var dropdownContainer = "_mp-5";
export var dropdownImage = "_mp-6";
export var editAssigneeForm = "_mp-a";
export var editButton = "_mp-3";
export var email = "_mp-7";
export var hidden = "_mp-d";
export var input = "_mp-8";
export var saveButton = "_mp-b";
export var shopifyIcon = "_mp-c";
export var suggestionBadge = "_mp-e";
export var suggestionText = "_mp-f";
export var username = "_mp-9";